import universalImport from 'babel-plugin-universal-import/universalImport';
import universal from 'react-universal-component';
import path from 'path';
import LazyComponent from '../LazyComponent';

export default universal(
    universalImport({
        chunkName: () => 'LazyCAMChunks',
        path: () => path.join(__dirname, './WalletWrapper'),
        resolve: () => require.resolveWeak('./WalletWrapper'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "WalletWrapperChunks" */ './WalletWrapper'), // css name
            ]).then((proms) => proms[0]),
    }),
    LazyComponent.loaderResource
);
